const state = {
  info: null,
  userlevel: null,
  extraInfo:null,
  token: null,
  mac:'',
  loginType:5,
  pid:'167',
  qid:'61000',
  sqid:'0',
  version:'1.0.0',
  phonetype:'pc',
  accountBalance: 0,
  roomLoginInfo: {}
}
const mutations = {
  UISTATE_UPDATE_LOGIN_USER_INFO(state, data) {
    state.info = data.info;
    state.token = data.token;
    sessionStorage.setItem('userInfo',JSON.stringify(data.info));
    sessionStorage.setItem('token',data.token);
  },
  LOGIN_USER_UPDATE_LOGIN_USER_INFO(state, data) {
    state.roomLoginInfo = data;
  },
  UPDATE_ACCOUNT_BALANCE(state, balance) {
    state.accountBalance = balance;
  },
  UPDATE_LOGIN_TYPE(state, type) {
    state.loginType = type;
  },
  UPDATE_LOGIN_USER_LEVEL(state, objLevel) {
    state.userlevel = objLevel;
  },
  UPDATE_LOGIN_EXTRA_INFO(state, extraInfo) {
    state.extraInfo = extraInfo;
  },
  UPDATE_LOGIN_PID(state, pid) {
    state.pid = pid;
  },
  UPDATE_LOGIN_QID(state, qid) {
    state.qid = qid;
  },
  UPDATE_LOGIN_SQID(state, sqid) {
    state.sqid = sqid;
  }
}

// this message is similar to post message. It's async
const actions = {
  uiState_update_login_user_info({
    commit
  }, data) {
    commit('UISTATE_UPDATE_LOGIN_USER_INFO', data)
  },
  upDateLoginType({state,commit},type){
    commit('UPDATE_LOGIN_TYPE',type)
  },
  upDateLoginUserLevel({state,commit},type){
    commit('UPDATE_LOGIN_USER_LEVEL',type)
  },
  upDateUserExtraInfo({state,commit},type){
    commit('UPDATE_LOGIN_EXTRA_INFO',type)
  }
}

export default {
  state,
  mutations,
  actions
}